
<template>
  <div class="upgrade-modal">
    <!-- Legacy banner -->
    <div class="legacy-banner">
      <div class="flex items-center gap-2">
        <component
          :is="bannerInfo.icon"
          :class="bannerInfo.iconClass"
        />
        <BaseText
          class="text-white whitespace-nowrap"
          type="label"
          size="sm"
        >
          {{ bannerInfo.text }}
        </BaseText>
        <div
          v-if="bannerInfo.code"
          class="px-2 py-0.5 rounded-2xl"
          style="background-color: rgba(0, 194, 108, 0.29)"
        >
          <BaseText
            class="text-secondary-green-100"
            type="label"
            size="xs"
          >
            {{ bannerInfo.code }}
          </BaseText>
        </div>
      </div>
      <button
        v-if="demoVideo"
        class="flex items-center gap-2 dark-base-btn text-white p-2 pl-3 flex-shrink-0"
        @click="openDemoVideo"
      >
        <PlayIcon />
        <BaseText
          type="label"
          size="sm"
        >
          Watch Demo
        </BaseText>
      </button>
    </div>
    <div>
      <div class="p-5 space-y-2">
        <BaseText
          type="heading"
          size="sm"
          class="text-text-muted"
        >
          {{ upgradeHeader }}
        </BaseText>
        <BaseText
          size="sm"
          class="text-text-normal"
        >
          {{ upgradeCopy }}
        </BaseText>
      </div>
      <div class="p-5 flex flex-col justify-between gap-7">
        <div class="space-y-2.5">
          <BaseText
            type="label"
            size="sm"
            class="text-text-normal"
          >
            What you get when upgrading:
          </BaseText>
          <div
            v-for="(benefit, index) in upgradeBenefits"
            :key="index"
            class="flex items-center gap-1.5"
          >
            <NewCheckmarkIcon class="text-secondary-green-100" />
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              {{ benefit }}
            </BaseText>
          </div>
        </div>
        <button
          class="black-btn-primary text-white rounded-md w-full py-1.5 px-3"
          @click="SET_SUBSCRIPTION_DRAWER_VIEW_MODE({state: true})"
        >
          <BaseText
            type="label"
            size="sm"
          >
            Choose a Plan
          </BaseText>
        </button>
      </div>
    </div>
    <!-- Custom -->
    <div class="bg-background-normal rounded-2xl relative pt-4 lg:pt-6 px-5 flex items-center justify-between flex-col h-full gap-11 overflow-hidden text-center">
      <div>
        <BaseText
          type="heading"
          size="sm"
          class="text-text-muted"
        >
          Need Something Custom?
        </BaseText>
        <BaseText
          class="mt-1 text-text-normal"
          size="sm"
        >
          Save up to 80% with custom plans.
        </BaseText>
        <div class="flex items-center justify-center flex-col gap-3 mt-4 xl:mt-7">
          <button
            class="bg-white base-btn flex items-center justify-center w-32 py-1.5 px-3"
            @click="openDemoBook"
          >
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              Book a Demo
            </BaseText>
          </button>
          <BaseText
            size="xs"
            class="text-text-normal text-center"
          >
            Only for plans larger than Agency.
          </BaseText>
        </div>
      </div>
      <img
        v-if="productImage"
        class="product-image"
        :src="productImage"
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
// Icons
import NewCheckmarkIcon from '../globals/Icons/NewCheckmarkIcon.vue'
import CouponIcon from '../globals/Icons/CouponIcon.vue'
import MetricsIcon from '../globals/Icons/LensIcons/MetricsIcon.vue'
import PlayIcon from '../globals/Icons/PlayIcon.vue'

export default {
  name: 'PaywallCard',
  components: {
    NewCheckmarkIcon,
    CouponIcon,
    PlayIcon,
    MetricsIcon
  },
  props: {
    subscriptionType: {
      type: Object,
      default: () => {}
    },
    upgradeHeader: {
      type: String,
      default: 'Upgrade your account to unlock Lens & Spyder.'
    },
    upgradeCopy: {
      type: String,
      default: 'Upgrade to “Workflow” or “Agency” plans to unlock Lens creative analytics.'
    },
    upgradeBenefits: {
      type: Array,
      default: () => []
    },
    learnMore: {
      type: String,
      default: 'Learn more'
    },
    productImage: {
      type: [String, null],
      default: null
    },
    demoVideo: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    bannerInfo () {
      const subscriptionType = this.subscriptionType

      if (subscriptionType.isLegacy) {
        return {
          text: 'Legacy users enjoy an additional 10% off for life',
          code: 'Code: LEGACY10',
          iconClass: 'text-secondary-green-100',
          icon: CouponIcon
        }
      } else {
        return {
          text: this.learnMore,
          iconClass: 'text-white',
          icon: MetricsIcon
        }
      }
    }
  },
  methods: {
    ...mapMutations('MiscModule', ['SET_SUBSCRIPTION_DRAWER_VIEW_MODE']),
    openDemoVideo () {
      window.open(this.demoVideo, '_blank')
    },
    openDemoBook () {
      window.open('https://www.foreplay.co/book-demo', '_blank')
    }
  }
}
</script>

<style scoped>
.paywall-container{
  position: relative;
  width: 100%;
  height: calc(100vh - 86px);

  display: flex;
  justify-content: center;
  align-items: center;
}
.blurry-background {
  filter: blur(8px);
  height: calc(100% + 52px);
  -webkit-filter: blur(8px);
}

.upgrade-modal{
  display: grid;
  position: relative;;
  grid-template-columns: 480px 360px;
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 24px 32px -12px rgba(53, 57, 75, 0.24), 0px 1px 2px 0px rgba(162, 172, 186, 0.16), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  box-shadow: 0px 24px 32px -12px color(display-p3 0.21 0.2233 0.29 / 0.24), 0px 1px 2px 0px color(display-p3 0.6433 0.6728 0.7254 / 0.16), 0px 0px 0px 1px color(display-p3 0.0696 0.2157 0.4104 / 0.08);
  z-index: 10;
  padding: 4px;
}

.product-image{
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  bottom: -2.75rem;
}

@media (max-width: 1208px) {
  .upgrade-modal {
    grid-template-columns: 1fr !important;
  }
  .product-image{
    display: none;
  }
  .legacy-banner{
    width: max-content !important;
  }
}

.base-btn {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}

.legacy-banner{
  background: rgba(6, 7, 15, 1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: space-between;
  padding: 12px 20px;
  border-radius: 20px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  width: 100%;
  height: 60px;

  bottom: calc(100% + 8px);
}

.dark-base-btn{
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.10);
  transition: 150ms ease-in-out;
}
.dark-base-btn:hover{
  background: rgba(255, 255, 255, 0.20);

}
</style>
